// extracted by mini-css-extract-plugin
export default {"loadingScreen":"AppLoader_loadingScreen__Fpx1l","loader":"AppLoader_loader__hwI9N","rikSpikeRoll":"AppLoader_rikSpikeRoll__2KQQr"};